<template>
  <div>
    <OverlayLoading :loading="loading" />
  <v-row class="pt-2 pb-0">
      <v-item-group
        mandatory
        v-model="tapSelect"
        @change="searchFilterData(), page=1"
      >
        <v-container>
          <v-row>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12">
              <v-item v-slot="{ active, toggle }" >
                <v-card
                  :color="active ? '#EFF4FD' : '#F8F9FA'"
                  :class="`pa-0 ma-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-format-list-bulleted</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ totalAll }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">คำร้องทั้งหมด</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12" v-show="approveRole==='Admin' || approveRole==='Super Admin' || approveRole==='User'">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FEF5E9' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#E9A016'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#E9A016' : '#FEF5E9' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-clock-time-four-outline</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #E9A016;">{{ totalPending }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">รออนุมัติ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12" v-show="approveRole==='User'">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#EFF4FD' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#00B0FF'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#00B0FF' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-timelapse</v-icon>
                  </v-col>
                  <v-col cols=8 class="mt-0 pt-1">
                    <span style="font-weight: 500; font-size: 24px; color: #00B0FF;">{{ totalWaiting }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">กำลังดำเนินการ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6" xs="12">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#ECF8EA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="350"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7" lg="7" md="7" sm="4" xs="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#58A144'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#58A144' : '#ECF8EA' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-check-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="5" lg="5" md="5" sm="8" xs="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #58A144;">{{ totalApproved }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">อนุมัติแล้ว</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
  </v-row>
  <v-row class="pt-0">
    <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ชื่อพนักงาน</span>
      <v-autocomplete
        v-model="keywordEmployeeName"
        :items="itemUserName"
        item-text="dataShow"
        item-value="dataShow"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาได้จากชื่อ-นามสกุลพนักงาน"
        no-data-text="ไม่พบข้อมูล"
        @change="searchFilterData(), page=1"
        @click:clear="keywordEmployeeName='', searchFilterData(), page=1"
      >
      <template v-slot:append>
        <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">หมายเลขคำร้อง</span>
      <v-autocomplete
        v-model="keywordRequestNo"
        :items="itemRequestNo"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาหมายเลขคำร้อง"
        no-data-text="ไม่พบข้อมูล"
       @change="searchFilterData(), page=1"
        @click:clear="keywordRequestNo=[], searchFilterData(), page=1"
      >
      <!-- v-on:keyup.enter="searchFilterData(), page=1" -->
      <template v-slot:append>
        <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="1" class="pt-0 d-flex align-end" style="padding-bottom: 15px;">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        :nudge-top='-10'
        max-width="328"
        left
        offset-y
        origin='left'
        tile
        z-index="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="head-search-button"
            style="width: 96px; height: 38px;"
            text
            color="primary"
            elevation="0"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left>
              mdi-filter-variant
            </v-icon>
            ตัวกรอง
          </v-btn>
        </template>
        <v-card class="pa-3">
          <v-row class="pt-3">
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">สิทธิ์</span>
              <v-autocomplete
                v-model="keywordAuthenName"
                :items="itemAuthenName"
                item-text="name"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="d-flex">
            <v-spacer/>
            <v-btn
              class="head-search-button mr-2"
              outlined
              color="primary"
              style="width: 60px;"
              elevation="0"
              @click="resetFilterData()"
            >ล้าง</v-btn>
            <v-btn
              class="btn-search-dep ml-2 mr-3"
              color="primary"
              style="width: 94px;"
              dark
              @click="searchFilterData()"
            >ค้นหา</v-btn>
          </v-row>
        </v-card>
      </v-menu>
    </v-col>
    <v-spacer/>
  </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import {
  getSelectApproveRequestTransferrole
} from '@/API/API'
// import axios from 'axios'
import OverlayLoading from '../../_template/OverlayLoading.vue'
export default {
  name: 'filter-workgroup',
  props: {
    mode: String
  },
  components: {
    OverlayLoading
  },
  data () {
    return {
      loading: false,
      tapData: ['', 'pending', 'waiting', 'approve', 'reject'],
      tapSelect: 0,
      keywordEmployeeName: '',
      keywordRequestNo: [],
      keywordType: [],
      keywordAuthenName: [],
      itemUserName: [],
      itemAuthenName: [],
      itemRequestNo: [],
      filterData: {
        reqEmployeeNo: '',
        employeeName: '',
        authenName: [],
        requestStatus: [],
        approveType: this.mode,
        limit: 50,
        page: 1
      },
      selectData: {
        authenName: [],
        requestType: [],
        status: [
          { value: 'pending', text: 'รอการอนุมัติ' },
          { value: 'approve', text: 'อนุมัติ' },
          { value: 'reject', text: 'ปฏิเสธอนุมัติ' }
        ],
        statusAct: [
          { value: 'pending', text: 'รอการรับทราบ' },
          { value: 'acknowledge', text: 'รับทราบ' }
        ]
      },
      menu: false,
      totalAll: 0,
      totalWaiting: 0,
      totalPending: 0,
      totalApproved: 0,
      totalRejected: 0,
      allowBtnApprove: false,
      allowBtnReject: false,
      textBtnOk: this.mode === 'approve' ? 'Approve' : 'Acknowledge',
      textBtnNO: this.mode === 'approve' ? 'Reject' : 'Unacknowledge',
      approveRole: localStorage.approveRole
    }
  },
  watch: {
    // approveRole () { return localStorage.approveRole }
  },
  computed: {
    // approveRole () { return localStorage.approveRole }
  },
  async created () {
    await this.getSelectData()
    await this.searchFilterData()
  },
  beforeDestroy () {
    EventBus.$off('manageApproveTransferSearch')
    EventBus.$off('updateTotalAuthen')
    EventBus.$off('setApproveRole')
  },
  mounted () {
    EventBus.$on('updateTotalAuthen', this.updateTotal)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  methods: {
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      this.page = 1
      this.resetFilterData()
      await this.getSelectData(this.approveRole)
      await this.searchFilterData()
    },
    updateTotal (value) {
      this.totalAll = value.totalAll
      this.totalPending = value.totalPending
      this.totalApproved = value.totalApproved
      this.totalRejected = value.totalRejected
      this.totalWaiting = value.totalWaiting
    },
    async getSelectData (role) {
      this.loading = true
      this.itemUserName = []
      const obj = {
        role: role
      }
      try {
        // const res = await getSelectApproveRequestCompany({ approveType: this.mode, role: this.approveRole }, this.$store.state.token)
        const res = await getSelectApproveRequestTransferrole(obj, this.$store.state.token)
        if (res.success) {
          if (res.result) {
            this.itemAuthenName = res.result.authen
            this.itemRequestNo = res.result.reqNo
            res.result.name.map(el => {
              this.itemUserName.push({
                dataShow: el.employeeId + ' - ' + el.name,
                ...el
              })
            })
          }
          this.loading = false
        }
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    resetFilterData () {
      this.keywordEmployeeName = ''
      this.keywordRequestNo = ''
      this.keywordAuthenName = []
      this.filterData = {
        reqEmployeeNo: '',
        authenName: [],
        approveType: this.mode
      }
      this.searchFilterData(1, 15)
    },
    searchFilterData () {
      this.filterData = {
        searchNameAndEmpId: this.keywordEmployeeName,
        reqTransferroleNo: [this.keywordRequestNo],
        authenName: this.setObjFilter(this.keywordAuthenName),
        status: this.setObjFilter(this.tapData[this.tapSelect]),
        role: this.approveRole,
        tab: this.mode
      }
      EventBus.$emit('manageApproveTransferSearch', this.filterData)
    },
    setObjFilter (data) {
      return (typeof data === 'string') ? [data] : data
    },
    removeChip (item) {
      const index = this.keywordType.indexOf(item.requestTypeEng)
      if (index >= 0) this.keywordType.splice(index, 1)
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
</style>
